import { render, staticRenderFns } from "./publishStatusList.vue?vue&type=template&id=28ebff85&scoped=true&"
import script from "./publishStatusList.vue?vue&type=script&lang=js&"
export * from "./publishStatusList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ebff85",
  null
  
)

export default component.exports